import { NullableString } from "@/code/Types";

export class LoginModel {
  email: NullableString = null;
  otp: NullableString = null;
}
